module.exports = __webpack_public_path__ + "static/media/werbeflyer_heuschrecken.6105bb4e.pdf";